export var MAXIMUM_SCREEN_WIDTH_FOR_TWO_MONTH_CALENDAR = 800;
export var LOADING_PLACEHOLDER_TEXT = '';